import { GoogleOAuthProvider } from "@react-oauth/google";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { EnvService } from "namirasoft-core";
import GoogleLoginButton from "./GoogleLoginButton";

import Style from "./AccountGoogleLogin.module.css";

interface AccountGoogleLoginProps extends NSARouterMakerResult { }

export function AccountGoogleLogin(props: AccountGoogleLoginProps)
{
    let REACT_APP_GOOGLE_CLIENT_ID = new EnvService("REACT_APP_GOOGLE_CLIENT_ID", true).getString();

    return (
        <GoogleOAuthProvider clientId={REACT_APP_GOOGLE_CLIENT_ID}>
            <div className={Style.ns_account_google_login}>
                <GoogleLoginButton {...props} />
                {/* <GoogleLogin
                    onSuccess={(res) => {
                        if (res.clientId)
                            if (res.credential)
                                props.account.server.user
                                    .Google({
                                        client_id: res.clientId,
                                        credential: res.credential,
                                    })
                                    .then(() => {
                                        props.url.redirect(AccountRoutes.Home, {});
                                    })
                                    .catch(() => {});
                    }}
                    onError={() => {}}
                    useOneTap
                /> */}
            </div>
        </GoogleOAuthProvider>
    );
}